import api from "../../axiosConfig";

export const addReferDoctor = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/refer-doctor/add', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getreferDoctor = async (searchKeyword,doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('refer-doctor/all', {
      params: {
        search_keyword: searchKeyword,
        doctor_id:doctor_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const updatereferDoctor = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    _method: 'put', 
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`refer-doctor/update/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
export const deleteReferDoctor = async (id) => {
  try {
    const response = await api.delete(`refer-doctor/delete/${id}`);

    const resData = response?.data;
    console.log('Delete refer doctor response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting refer doctor');
  }
};